import React from 'react';
import * as styles from './ToolbarNav.module.css';
import { Button, Icon, IconList } from 'components/core';

export type ToolbarNavProps = {
  backUrl: string;
  title?: string;
  left?: JSX.Element;
  right?: JSX.Element;
};

export default function ToolbarNav({
  backUrl,
  title,
  left,
  right,
}: ToolbarNavProps): JSX.Element {
  return (
    <nav className={styles.nav}>
      <Button
        to={backUrl}
        iconOnly
        className={styles.backButton}
        aria-label="Back"
        variant="ghost"
      >
        <Icon icon={IconList.light.faArrowLeft} />
      </Button>
      {title && <h2 className={styles.title}>{title}</h2>}
      {left && <div className={styles.left}>{left}</div>}
      {right && <div className={styles.right}>{right}</div>}
      <Button
        isNaked={true}
        data-target="#feedback-and-support"
        data-toggle="modal"
        className={styles.help}
      >
        <Icon icon={IconList.light.faQuestionCircle} />
      </Button>
    </nav>
  );
}
